import { t } from '@/utility/localization';

/**
 * Complementary component to display default images that can be chosen by the user
 * @param defaultImages Array of default images, must be an array of string URLs
 * @param onPickImage Callback called when user clicked on one of the image
 * @returns {JSX.Element}
 * @constructor
 */
const ByDefaultGallery = ({ defaultImages, onPickImage }) => {
  const pickInput = (img) => {
    onPickImage(img);
  };
  return (
    <div className="min-h-[220px]">
      <div className="grid grid-cols-4 gap-8">
        {defaultImages.map((image, index) => (
          <button
            onClick={() => pickInput(image)}
            key={image}
            type="button">
            <img
              src={image}
              alt={`${t('event-gradient')} ${index}`}
              className="cursor-pointer rounded-4 hover:opacity-80"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ByDefaultGallery;
